import React from 'react';
import { render } from 'preact';
import { BaseComponent } from 'project/general';
import ProductListController from './product-list.controller';

const FETURED_SECTION_ID = 'featured-products-section';

class ProductComponent extends BaseComponent {
    static getNamespace() {
        return 'product-list';
    }

    onInit() {
        render(<ProductListController {...this.initData}
            showTitleFlag={ProductComponent.isFeaturedSectionShown()} />, this.element);
    }

    static isFeaturedSectionShown() {
        return document.querySelector(`#${FETURED_SECTION_ID}`) !== null;
    }
}

export default ProductComponent;
